// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import GridIcon from './GridIcon.view';
import ListIcon from './ListIcon.view';

const Icons = {
  'grid-icon': GridIcon,
  'list-icon': ListIcon,
};

const Icon = ({ icon, ...rest }) => {
  const IconComponent = Icons[icon];

  if (!IconComponent) {
    return null;
  }

  return <IconComponent {...rest} />;
};

Icon.propTypes = {
  icon: PropTypes.string,
};

Icon.defaultProps = {
  icon: '',
};

export default Icon;
